import React from 'react';
import { Card } from 'react-bootstrap';

const Section: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return (
    <Card>
      <Card.Body>{children}</Card.Body>
    </Card>
  );
};

export default Section;
